import { useState } from 'react'
import { GripVertical, X } from 'lucide-react'

function SortableAttributeChips({ attrs, onReorder, onRemove }) {
  const [dragIndex, setDragIndex] = useState(null)

  if (!attrs || attrs.length === 0) return null

  const handleDrop = (dropIndex) => {
    if (dragIndex === null || dragIndex === dropIndex) return
    const next = attrs.slice()
    const [moved] = next.splice(dragIndex, 1)
    next.splice(dropIndex, 0, moved)
    onReorder(next)
    setDragIndex(null)
  }

  return (
    <ul className="mt-2 space-y-1.5">
      {attrs.map((attr, index) => (
        <li
          key={attr}
          draggable
          onDragStart={() => setDragIndex(index)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={() => handleDrop(index)}
          onDragEnd={() => setDragIndex(null)}
          className="flex items-center gap-2 px-2.5 py-1.5 bg-gray-50 border border-gray-200 rounded-md text-sm text-gray-800 cursor-grab active:cursor-grabbing"
        >
          <GripVertical className="h-3.5 w-3.5 text-gray-400 flex-shrink-0" />
          <span className="flex-1 overflow-hidden text-ellipsis whitespace-nowrap" title={attr}>{attr}</span>
          <button
            type="button"
            onClick={() => onRemove(attr)}
            className="text-gray-400 hover:text-gray-600 flex-shrink-0"
            title="Entfernen"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </li>
      ))}
    </ul>
  )
}

export default SortableAttributeChips
